export const FIELDS = [
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'clientName',
    inputAdornment: '',
    label: 'Nombre completo',
    disabled: false,
    required: true,
  },
  {
    name: 'phoneMandate',
    inputAdornment: '',
    label: 'Teléfono mandato',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'mobileOperator',
    inputAdornment: '',
    label: 'Operador',
    disabled: false,
    required: true,
    inputType: 'select',
  },
  {
    name: 'charge',
    inputAdornment: '',
    label: 'Monto cargo',
    disabled: false,
    required: true,
  },
  {
    name: 'email',
    inputAdornment: '',
    label: 'Correo',
    disabled: false,
    required: true,
  },
  {
    name: 'phone',
    inputAdornment: '',
    label: 'Teléfono de contacto',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'comment',
    inputAdornment: '',
    label: 'Escribir comentario',
    disabled: false,
    required: false,
    rows: 4,
    multiline: true,
  },
];
